import { useSelector } from 'react-redux';

import moment from 'moment-timezone';

const useGetTimeZone = () => {
  const currentUser = useSelector(({ user }) => user.profile.data);
  const timeZoneFallback = moment.tz.guess();
  const timeZone = currentUser?.timeZone || timeZoneFallback;

  return timeZone;
};

export default useGetTimeZone;
